import React from 'react';

function ContactForm({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M2.65 6.35h7.7M2.65 10.35h4.7M2.65 14.35h1.7" />
      <path d="M19.15 9.9l-8.82 8.8L6 20l1.32-4.35 8.82-8.8m3 3.05l-3-3.05m3 3.05l2.16-2.15a1 1 0 000-1.4l-1.6-1.63a1 1 0 00-1.42 0l-2.14 2.13M8.13 15.73l2.14 2.14" />
    </svg>
  );
}

export default ContactForm;
